import {Information} from "../../src/interfaces/interfaces";

const informace : Information[] = [
    {
        date: '25.8.2023',
        pdf: 'Informace 25.8.2023.pdf',
        description: '',
    },
    {
        date: '8.9.2023',
        pdf: 'Informace 8.9.2023.pdf',
        description: '',
    },
    {
        date: '15.9.2023',
        pdf: 'Informace 15.9.2023.pdf',
        description: '',
    },
    {
        date: '21.9.2023',
        pdf: 'Informace 21.9.2023 - pro P a PP.pdf',
        description: 'pro P a PP',
    },
    {
        date: '10.10.2023',
        pdf: 'Informace 10.10.2023.pdf',
        description: '',
    },
    {
        date: '17.10.2023',
        pdf: 'Informace 17.10.2023.pdf',
        description: '',
    },
    {
        date: '5.11.2023',
        pdf: 'Informace 5.11.2023.pdf',
        description: '',
    },
    {
        date: '13.11.2023',
        pdf: 'Informace 13.11.2023.pdf',
        description: '',
    },
    {
        date: '16.11.2023',
        pdf: 'Informace 16.11.2023.pdf',
        description: '',
    },
    {
        date: '16.11.2023',
        pdf: 'Informace 16.11.2023-přípravky.pdf',
        description: 'přípravky',
    },
    {
        date: '8.1.2024',
        pdf: 'Informace 8.1.2024.pdf',
        description: '',
    },
    {
        date: '9.1.2024',
        pdf: 'Informace 9.1.2024-PŘÍPRAVKA-2018.pdf',
        description: 'PŘÍPRAVKA-2018',
    },
    {
        date: '9.1.2024',
        pdf: 'Informace 9.1.2024-PŘÍPRAVKA-2019 A MLADŠÍ.pdf',
        description: 'PŘÍPRAVKA-2019 A MLADŠÍ',
    },
    {
        date: '16.1.2024',
        pdf: 'Informace 16_1_2024.pdf',
        description: '',
    },
    {
        date: '29.1.2024',
        pdf: 'Informace 29.1.2024.pdf',
        description: '',
    },
    {
        date: '9.2.2024',
        pdf: 'Informace 9.2.2024.pdf',
        description: '',
    },
    {
        date: '21.2.2024',
        pdf: 'Informace 21.2.2024.pdf',
        description: '',
    },
    {
        date: '28.2.2024',
        pdf: 'Informace 28.2.2024.pdf',
        description: '',
    },
    {
        date: '29.2.2024',
        pdf: 'Informace 29.2.2024.pdf',
        description: '',
    },
    {
        date: '8.3.2024',
        pdf: 'Informace 8_3_2024.pdf',
        description: '',
    },
    {
        date: '18.3.2024',
        pdf: 'Informace 18_3_2024.pdf',
        description: '',
    },
    {
        date: '30.3.2024',
        pdf: 'Informace 30_3_2024.pdf',
        description: '',
    },
    {
        date: '2.4.2024',
        pdf: 'Informace 2.4.2024.pdf',
        description: '',
    },
    {
        date: '12.4.2024',
        pdf: 'Informace 12_4_2024.pdf',
        description: 'Vyškovský pohár',
    },
    {
        date: '18.4.2024',
        pdf: 'závody 2024-k 10.4..pdf',
        description: 'závody jaro 2024 - k 10.4.',
    },
    {
        date: '22.4.2024',
        pdf: 'Informace 22_4_2024.pdf',
        description: 'OP NML A a NST A',
    },
    {
        date: '23.4.2024',
        pdf: 'Informace 23.4.2024.pdf',
        description: '',
    },
    {
        date: '26.4.2024',
        pdf: 'Upřesnění nominace OP + ESG.pdf',
        description: 'Upřesnění nominace OP + ESG',
    },
    {
        date: '29.4.2024',
        pdf: 'Informace 29.4.2024.pdf',
        description: 'Informace k Milevsku, Ostravě a SPRING Cupu',
    },
    {
        date: '4.5.2024',
        pdf: 'Informace 4.5.2024.pdf',
        description: 'Rozvrh od 6. 5., MČR NST B, JUN B',
    },
    {
        date: '10.5.2024',
        pdf: 'Informace 10_5_2024.pdf',
        description: 'Traskáček',
    },
    {
        date: '11.5.2024',
        pdf: 'Informace 11.5.2024.pdf',
        description: 'Rozvrh od 13.5., MČR, ...',
    },
    {
        date: '13.5.2024',
        pdf: 'Informace 13.5.2024.pdf',
        description: 'Kontrolní závod 18. 5. pro NML, NST, JUN a SEM A',
    },
    {
        date: '21.5.2024',
        pdf: 'Informace 21.5.2024.pdf',
        description: '',
    },
    {
        date: '31.5.2024',
        pdf: 'Soustředění léto 2024.pdf',
        description: 'Informace k letnímu soustředění - Sezimovo Ústí, Ústí nad Orlicí, Vyškov',
    },
    {
        date: '17.8.2024',
        pdf: 'bezinfekčnost Ústí + Vyškov.pdf',
        description: 'bezinfekčnost Ústí nad Orlicí, Vyškov',
    },
     {
        date: '23.8.2024',
        pdf: 'informace 23.8.2024.pdf',
        description: '',
    },
    {
        date: '28.8.2024',
        pdf: 'informace 28.8.2024.pdf',
        description: '',
    },
    {
        date: '10.9.2024',
        pdf: 'Informace 10_9_2024.pdf',
        description: '',
    },
    {
        date: '29.9.2024',
        pdf: 'Informace 29.9.2024.pdf',
        description: '',
    },
    {
        date: '11.10.2024',
        pdf: 'Informace 11_10_2024.pdf',
        description: '',
    },
    {
        date: '4.11.2024',
        pdf: 'Informace 4_11_2024.pdf',
        description: '',
    },
    {
        date: '12.11.2024',
        pdf: 'Informace 12.11.2024.pdf',
        description: '',
    },
    {
        date: '21.12.2024',
        pdf: 'Informace 21_12_2024.pdf',
        description: '',
    },
    {
        date: '21.12.2024',
        pdf: 'sestavy 2025.pdf',
        description: 'Sestavy 2025',
    },
    {
        date: '21.12.2024',
        pdf: 'Skládání sestav 2025.pdf',
        description: 'Skládání sestav 2025',
    },
    {
        date: '6.1.2025',
        pdf: 'Informace 6.1.2025.pdf',
        description: '',
    },
    {
        date: '13.1.2025',
        pdf: 'Informace 13.1.2025.pdf',
        description: '',
    },
    {
        date: '21.1.2025',
        pdf: 'Informace 21.1.2025.pdf',
        description: '',
    },
    {
        date: '2.2.2025',
        pdf: 'Informace 2.2.2025.pdf',
        description: '',
    },
    {
        date: '2.2.2025',
        pdf: '2025-skoleni-ro-oh-cyklus-2025-28-propozice-jsomg.pdf',
        description: 'Propozice ke školení RO na nový olympijský cyklus',
    },
    {
        date: '12.2.2025',
        pdf: 'Informace 12.2.2025.pdf',
        description: '',
    },
    {
        date: '5.3.2025',
        pdf: 'Informace 5.3.2025.pdf',
        description: '',
    },
    {
        date: '7.3.2025',
        pdf: 'Informace 7_3_2025.pdf',
        description: '',
    },
    {
        date: '16.3.2025',
        pdf: 'Informace 16_3_2025.pdf',
        description: '',
    },
    {
        date: '16.3.2025',
        pdf: 'závody jaro 2025.pdf',
        description: '',
    },
    {
        date: '31.7.2025',
        pdf: 'Soustředění léto 2025.pdf',
        description: 'Informace k soustředění Ústí nad Orlicí a Vyškov',
    },
    {
        date: '31.7.2025',
        pdf: 'bezinfekčnost Ústí + Vyškov.pdf',
        description: 'bezinfekčnost Ústí a Vyškov',
    },
    {
        date: '22.8.2025',
        pdf: 'informace 22.8.2025.pdf',
        description: '',
    },
    {
        date: '28.8.2025',
        pdf: 'informace 28.8.2025.pdf',
        description: '',
    },
    {
        date: '10.9.2025',
        pdf: 'Informace 10_9_2025.pdf',
        description: '',
    },
    {
        date: '23.9.2025',
        pdf: 'Informace 23.9.2025.pdf',
        description: '',
    },
    {
        date: '23.9.2025',
        pdf: 'závody podzim 2025.pdf',
        description: 'závody podzim 2025',
    },
    {
        date: '8.10.2025',
        pdf: 'Informace 8_10_2025.pdf',
        description: '',
    },
    {
        date: '14.10.2025',
        pdf: 'Informace 14_10_2025.pdf',
        description: '',
    },
    {
        date: '21.10.2025',
        pdf: 'Informace 21_10_2025.pdf',
        description: '',
    },
    {
        date: '16.11.2025',
        pdf: 'Informace_16.11.2025.pdf',
        description: '',
    },
    {
        date: '14.1.2026',
        pdf: 'Informace 14.1.2026.pdf',
        description: '',
    },
    {
        date: '27.1.2026',
        pdf: 'AMERIKA 2025-26.pdf',
        description: 'AMERIKA 2025-26 - pořadí a provedení cviků z Ameriky',
    },
    {
        date: '3.2.2026',
        pdf: 'Informace 3.2.2026.pdf',
        description: '',
    },
    {
        date: '12.2.2026',
        pdf: 'Informace 12.2.2026.pdf',
        description: '',
    },
     {
        date: '10.8.2026',
        pdf: 'Soustředění léto 2026.pdf',
        description: 'informace k soustředění 2026',
    },
     {
        date: '10.8.2026',
        pdf: 'bezinfekčnost Ústí + Vyškov.pdf',
        description: 'bezinfekčnost Ústí + Vyškov',
    },
     {
        date: '21.8.2026',
        pdf: 'informace 21.8.2026.pdf',
        description: '',
    },
    {
        date: '28.8.2026',
        pdf: 'informace 28.8.2026.pdf',
        description: '',
    },
    {
        date: '19.9.2026',
        pdf: 'Informace 19_9_2026.pdf',
        description: '',
    },
    {
        date: '19.9.2026',
        pdf: 'závody podzim 2026.pdf',
        description: 'závody podzim 2026',
    },
]

export default informace.reverse()
